var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonRefundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1056_1024)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 19.5293C6.18425 19.5293 1.875 15.6105 1.875 10.7793C1.875 5.94805 6.18425 2.0293 11.5 2.0293C16.8158 2.0293 21.125 5.94805 21.125 10.7793C21.125 15.6105 16.8158 19.5293 11.5 19.5293ZM11.5 0.779297C5.42456 0.779297 0.5 5.2543 0.5 10.7793C0.5 16.3043 5.42456 20.7793 11.5 20.7793C17.5754 20.7793 22.5 16.3043 22.5 10.7793C22.5 5.2543 17.5754 0.779297 11.5 0.779297ZM15.4304 7.20432C15.1595 6.96057 14.7216 6.96057 14.4507 7.20432L11.4959 9.89177L8.58362 7.24178C8.31481 6.99803 7.87893 6.99803 7.6115 7.24178C7.34268 7.48553 7.34268 7.88555 7.6115 8.1293L10.5238 10.773L7.59089 13.4418C7.32071 13.6856 7.32071 14.0855 7.59089 14.3355C7.86177 14.5793 8.30037 14.5793 8.57124 14.3355L11.5041 11.6668L14.4164 14.3168C14.6852 14.5606 15.1211 14.5606 15.3892 14.3168C15.658 14.0731 15.658 13.673 15.3892 13.4293L12.4762 10.7856L15.4304 8.09802C15.7006 7.84802 15.7006 7.45432 15.4304 7.20432Z",
    fill: "#EB662B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1056_1024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.779297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonRefundIcon);
export default __webpack_public_path__ + "static/media/non-refund-icon.efdba3fcfef684e11beb1fdaec78bb13.svg";
export { ForwardRef as ReactComponent };